import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCart } from "../../Context/CartContext";
import removeIcon from "../../assets/exit.png";
import logo from "../../assets/logo1.png";
import AlertOverlay from "./AlertOverlay";

const CartOverlay = ({ stat, toggleOverlay, setCheckoutOpen }) => {
  const { cart, removeItem, updateQuantity, getTotal } = useCart();
  const [alertState, setAlertState] = useState({
    open: false,
    title: "",
    message: "",
  });

  const openAlert = (title, message) => {
    setAlertState({ open: true, title, message });
  };

  const closeAlert = () => {
    setAlertState((prev) => ({ ...prev, open: false }));
  };

  const handleQuantityChange = (productId, operation) => {
    const item = cart.find((i) => i.productId === productId);
    if (!item) return;

    if (operation === "increase") {
      updateQuantity(productId, item.quantity + 1);
    } else if (operation === "decrease" && item.quantity > 1) {
      updateQuantity(productId, item.quantity - 1);
    }
  };

  const handleCheckoutClick = () => {
    if (cart.length === 0) {
      openAlert("Erreur", "Votre panier est vide");
      return;
    }
    setCheckoutOpen(true);
  };

  return (
    <>
    <motion.div
      className="overlay-container"
      initial={{ opacity: 0 }}
      animate={stat ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 0.2 }}
      style={{ display: stat ? "flex" : "none" }}
    >
      <div className="overlay-backdrop" onClick={toggleOverlay}></div>
      <motion.div
        className="overlay-content cart-overlay-container"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={stat ? { scale: 1, opacity: 1 } : { scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div
          onClick={toggleOverlay}
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            cursor: "pointer",
          }}
        >
          <img src={removeIcon} alt="close" style={{ width: "20px" }} />
        </div>

        <motion.div className="bold flex-column z-3 relative cart-overlay-content">
          <div>
            <p className=" bold">Votre Panier</p>
            <p className="small-text grey">Active Fitness.</p>
          </div>

          <div className="cart-items my-20 relative">
            {cart && cart.length > 0 ? (
              cart.map((item) => (
                <div className="cart-item my-10" key={item.productId}>
                  <div className="cart-item-left flex align-items-center justify-space-between">
                    <div className="flex align-items-center">
                      <div className="cart-item-img  bg-grey relative flex align-items-center justify-center">
                        <img
                          src={
                            item.imageUrl ||
                            (item.imagesUrls && item.imagesUrls[0]
                              ? item.imagesUrls[0]
                              : logo)
                          }
                          alt={item.productName || "Product"}
                        />
                      </div>
                      <div className="cart-item-infos  px-10 ml-40">
                        <p className="small-text grey">{item.productName}</p>
                        <p className="bold">{item.price} DA</p>
                        <div className="flex my-10">
                          <div
                            className="bg-orange white small-icon border-radius-5 flex align-items-center justify-center pointer"
                            onClick={() =>
                              handleQuantityChange(item.productId, "increase")
                            }
                          >
                            <p>+</p>
                          </div>

                          <p className="orange mx-10 bold">{item.quantity}</p>

                          <div
                            className="bg-grey small-icon border-radius-5 flex align-items-center justify-center pointer"
                            onClick={() =>
                              handleQuantityChange(item.productId, "decrease")
                            }
                          >
                            <p>-</p>
                          </div>
                        </div>
                      </div>

                      <img
                        alt="remove"
                        src={removeIcon}
                        className="small-icon  pointer remove-icon mobile"
                        onClick={() => removeItem(item.productId)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>


                    <div className="unit-price-container">
                      <p className="small-text grey">Prix</p>

                      <p className="orange bold">
                        {item.price * item.quantity}.00{" "}
                        <span className="small-text grey">DA </span>
                      </p>


                      
                    </div>

                     <img
                        alt="remove"
                        src={removeIcon}
                        className="small-icon  pointer remove-icon web"
                        onClick={() => removeItem(item.productId)}
                        style={{ cursor: "pointer" }}
                      />
                    
                  
                  </div>
                </div>
              ))
            ) : (
              <motion.div
                className="absolute center-text flex align-items-center justify-center w-full h-full"
                initial={{ opacity: 1 }}
              >
                <p className="small-text grey">Aucun article dans le panier</p>
              </motion.div>
            )}
          </div>

          {cart && cart.length > 0 && (
            <div
              className="cart-actions absolute bottom0 left0 f-width flex align-items-center justify-space-between px-20 py-20"
              style={{ boxSizing: "border-box" }}
            >
              <div>
                <p className="small-text grey">Prix Total</p>
                <p className="orange bold">
                  {getTotal().toFixed(2)}{" "}
                  <span className="small-text grey">DA</span>
                </p>
              </div>

              <motion.div className="action-button bg-orange fit-content">
                <motion.p className="btn" onClick={handleCheckoutClick}>
                  Passer Commande
                </motion.p>
              </motion.div>
            </div>
          )}
        </motion.div>
      </motion.div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </motion.div>
    <AlertOverlay
      stat={alertState.open}
      title={alertState.title}
      message={alertState.message}
      onClose={closeAlert}
      autoCloseMs={2500}
    />
    </>
  );
};

export default CartOverlay;
